import React from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import HelpInfoIcon from './HelpInfoIcon';
import FavoriteButton from './FavoriteButton';

const InterfaceHeader = ({
  title,
  color = '#8B5CF6',
  page = null,
  fontSize = '1.75rem',
  category = 'others',
  showFavorite = true,
}) => {
  const theme = useTheme();

  return (
    <>
      {showFavorite && <FavoriteButton interfaceName={title} category={category} />}
      {page && <HelpInfoIcon page={page} />}

      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: theme.palette.text.primary,
          textAlign: 'center',
          fontWeight: 700,
          fontSize: fontSize,
          textTransform: 'uppercase',
          letterSpacing: '0.1rem',
          textShadow: '1px 1px 3px rgba(0, 0, 0, 0.1)',
          borderBottom: `2px solid ${color}33`,
          pb: 1,
          mb: 4,
        }}
      >
        {title}
      </Typography>
    </>
  );
};

export default InterfaceHeader;